import { Injectable } from '@angular/core';
import * as auth0 from 'auth0-js';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { NotificationService } from './notification.service';

@Injectable()

export class AuthService {
    // Storage selection
    private storage = sessionStorage;

    // Accessor properties
    get accessToken(): string { return this.storage.getItem('accessToken'); }
    get profile() { return JSON.parse(this.storage.getItem('profile')); }
    get isAuthenticated(): boolean {
        return (this.storage.getItem('accessToken') !== null) ? true : false;
    }

    // Auth0 web authentication object
    auth0 = new auth0.WebAuth(environment.authWeb);

    constructor(private _router: Router, private _notify: NotificationService) {}

    // Using authentication object for login
    public login(): void { this.auth0.authorize(); }

    // Processing logout by clearing session.
    public logout(): void {
        this.storage.clear();
        this._router.navigate(['/']);
        // after logout notify and navigate to Landing Page
        this._notify.openDialog({
            color: 'primary', title: 'Authentication', body: 'You have been logged out successfully.'
        });
    }

    // Seting up accessor properties on successful authentication
    private authorize(authResult): void {
        this.storage.setItem('accessToken', authResult.accessToken);
        this.auth0.client.userInfo(authResult.accessToken, (error, profile) => {
            if (error === null) {
                this.storage.setItem('profile', JSON.stringify(profile));
                // after authentication notify and navigate to dashboard.
                this._router.navigate(['/dashboard']);
                this._notify.openDialog({
                    color: 'accent', title: 'Authentication',
                    body: `Hi ${profile.given_name} you are successfully authenticated.`
                });
            }
        });
    }

    // Processing hash returned in callbackUrl
    public handleAuthentication(): void {
        this.auth0.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                window.location.hash = '';
                this.authorize(authResult);
            } else if (err) {
                this._router.navigate(['/']);
                this._notify.openDialog({
                    color: 'warn', title: 'Authentication',
                    body: `Something went wrong please try again.`
                });
            }
        });
    }
}